import FadeInWrapper from "../../../components/common/fade-in-wrapper";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

// OnboardingPrice에서 사용되는 리뷰 데이터 (이미지 프리로딩용)
const reviews = [
  {
    src: "https://cdn-mahi.com/review3.png",
    alt: "review3",
    price: 7000,
    discountPrice: 3700,
  },
  {
    src: "https://cdn-mahi.com/review1.png",
    alt: "review1",
    price: 20000,
    discountPrice: 8900,
  },
  {
    src: "https://cdn-mahi.com/1750905351377-IMG_6469.jpeg",
    alt: "review0",
    price: 10000,
    discountPrice: 3900,
  },
  {
    src: "https://cdn-mahi.com/1755008789140-1000046936.jpg",
    alt: "review1",
    price: 22000,
    discountPrice: 9700,
  },
  {
    src: "https://cdn-mahi.com/1755082954288-1000015388.jpg",
    alt: "review1",
    price: 22000,
    discountPrice: 13200,
  },
  {
    src: "https://cdn-mahi.com/review2.png",
    alt: "review2",
    price: 10000,
    discountPrice: 4000,
  },
  {
    src: "https://cdn-mahi.com/1754994971653-image.jpg",
    alt: "review2",
    price: 25000,
    discountPrice: 13750,
  },
  {
    src: "https://cdn-mahi.com/review4.png",
    alt: "review4",
    price: 15000,
    discountPrice: 6900,
  },
  {
    src: "https://cdn-mahi.com/review5.png",
    alt: "review5",
    price: 20000,
    discountPrice: 8900,
  },
  {
    src: "https://cdn-mahi.com/review6.png",
    alt: "review6",
    price: 10000,
    discountPrice: 6200,
  },
];

const OnboardingStart = () => {
  const navigate = useNavigate();

  // 원본 + 리사이징된 이미지 모두 병렬로 프리로딩
  useEffect(() => {
    const preloadImages = () => {
      const deviceWidth = window.innerWidth > 742 ? 742 : window.innerWidth;
      const width = deviceWidth * 1;
      const dpr = window.devicePixelRatio > 1 ? 2 : 1;

      const allPromises = reviews.flatMap((review) => [
        // 원본 이미지
        new Promise((resolve) => {
          const img = new Image();
          img.onload = resolve;
          img.src = review.src;
        }),
        // 리사이징된 이미지
        new Promise((resolve) => {
          const img = new Image();
          img.onload = resolve;
          img.src = `${review.src}?w=${width * (dpr >= 2 ? 1.4 : 1)}&q=80`;
        }),
      ]);

      Promise.all(allPromises);
    };

    preloadImages();
  }, []);

  return (
    <div className="h-full bg-white min-h-screen relative pb-44">
      <>
        <FadeInWrapper className="flex flex-col h-full pt-4 px-4">
          {/* 타이틀 */}
          <div className="flex items-start mt-4 mb-4">
            <div
              className="w-2 h-full bg-blue-500 rounded-lg mr-4"
              style={{ minHeight: "150px" }}
            />
            <h1 className="text-5xl text-black font-[900] leading-snug">
              지갑지키미,
              <br />
              지구지키미,
              <br />
              마감히어로
            </h1>
          </div>
        </FadeInWrapper>

        <FadeInWrapper className="flex flex-col items-center gap-6 mt-20 px-4">
          <div className="w-full flex flex-row items-center justify-center gap-2">
            <div className="flex-1 bg-[#F3F6FA] rounded-2xl shadow-sm p-6 flex flex-col items-center">
              <span className="text-lg font-bold text-[#1562fc]">
                우리동네 <br />
                마감할인
              </span>
            </div>
            <span className="mx-2 text-3xl font-bold text-[#1562fc]">+</span>
            <div className="flex-1 bg-[#E6F0FF] rounded-2xl shadow-sm p-6 flex flex-col items-center">
              <span className="text-lg font-bold text-[#1562fc]">
                우리동네 <br /> 할인소식
              </span>
            </div>
          </div>
          <div className="text-center text-gray-700">
            모두 쏙쏙 알려드릴게요!
          </div>
        </FadeInWrapper>

        {/* 버튼 영역 */}
        <FadeInWrapper className="px-5 py-4 w-full fixed bottom-0 left-0">
          <Button
            onClick={() => navigate("/onboarding/price")}
            text="시작하기"
          />
        </FadeInWrapper>
      </>
    </div>
  );
};

export default OnboardingStart;

const Button = ({ onClick, text }: { onClick: () => void; text: string }) => {
  return (
    <FadeInWrapper className="inline w-full mt-4">
      <button
        onClick={onClick}
        className={`w-full h-[60px] flex items-center justify-center rounded-3xl font-bold ${"bg-blue-500  text-white"}`}
      >
        {text}
      </button>
    </FadeInWrapper>
  );
};
